import React from 'react'
import { connect } from 'react-redux'
import request from 'utils/request'

import PropTypes from 'prop-types'
import BaseComponent from 'utils/BaseComponent'
import Button from 'components/Button'
import Input from 'components/Input'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_POCS } from 'constants'

import './styles.scss'

export class PocModal extends BaseComponent {

  // Delegate method should be set to _onAccept() on props when the objected is created
  // Exameple: 
  // <ConfirmationModal _onAccept={this._delegateAcceptAction.bind(this)} match={this.props.match} />

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      phone: '',
      buttonProps: {
        disabled: false
      },
      errors: {
        name: [],
        phone: []
      }
    }
    this._bind('_handleSubmit', '_cancelSendReport', '_renderMessage', '_handleChange', '_createContact')
  }

  componentDidMount() {
    
  }

  _handleSubmit(e) {
    e.preventDefault()
    var errors = {
      name: [],
      phone: []
    }
    var form_ok = true
    e.preventDefault()
    if (this.state.name === '') {
      errors['name'] = ['El nombre es requerido']
      form_ok = false
    }
    if (this.state.phone === "") {
      errors['phone'] = ['El celular es requerido']
      form_ok = false
    }
    if (this.state.phone.length !== 10 || isNaN(this.state.phone)) {
      errors['phone'] = ['Se requieren 10 digitos']
      form_ok = false
    }
    this.setState({ "errors": errors })

    if (form_ok){
      this._createContact()
    }
  }

  _createContact(){
    const formData = new FormData()

    formData.append('name', this.state.name)
    formData.append('phone', this.state.phone) 

    this.props.updateRequestStatus('progress', 'Creando el punto de contacto...')
    request(CLAIM_POCS(this.props.claim.id), {
      method: 'POST',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Contacto registrado')
      this.props.claimChanged({
        ...this.props.claim,
        sms_enabled: true
      })
      this.props._onSuccess()
      this.context.toggleModal(false)  
      // this.setState({

      // })
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos crear el contacto')
      // this.props.claimChanged({
      //   ...this.props.claim,
      //   sms_enabled: true
      // })
      // this.props._onSuccess()
      this.context.toggleModal(false)  
    })

    this.setState({
      editting: false
    })
  }

  _handleChange(e) {
    var value = e.target.value
    this.setState({ [e.target.name]: value })
  }

  _cancelSendReport(e){
    this.context.toggleModal(false)
  }

  _renderMessage(){
    var message = "Ingresa un punto de contacto para que queden activadas las notificaciones"
    return (
      <div className="content">
        <p className="pocTitle">{ message }</p>
      </div>
    )
  }

  render() {
    var title = "Registrar punto de contacto de notificaciones SMS"
    var acceptLabel = this.props.acceptLabel || "Crear punto de contacto"
    return(
      <div id="PocModal" className="PocModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>{ title }</h1>
          <span className="material-icons close-button" onClick={this._cancelSendReport}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
            { this._renderMessage() }
            <p className="fieldTitle">Nombre *</p>
            <Input onChange={this._handleChange}
                name="name"
                value={this.state.name}
                placeholder="Ingresa el nombre"
                errors={this.state.errors.name}/>
            <br></br>
            <p className="fieldTitle">Celular *</p>
            <Input onChange={this._handleChange}
                name="phone"
                value={this.state.phone}
                placeholder="Ej: 9212050938"
                errors={this.state.errors.phone}/>
            <br></br>
            <center>
              <Button className="button"
                  size="small"
                  buttonType="primary"
                  {...this.state.buttonProps}>{ acceptLabel }</Button>
            </center>
        </form>
        <br></br>
      </div>
    )
  }
}

PocModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    state: state.clientDetail.get('state').toObject(),
    location: state.clientDetail.get('location').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PocModal)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/SMS/PocModal/index.js